import { Reducer } from "redux";

import { DocumentNoteUserListActionDispatchTypes } from "../constants/User";
import { ReferralNoteUserListResponse } from "../models/Api/User";
import { DocumentNoteUserListDispatchTypes } from "../models/DispatchTypes/User";

const initialState: ReferralNoteUserListResponse = {
  loading: false,
  response: [],
};

const DocumentNoteUserListReducer: Reducer<ReferralNoteUserListResponse, DocumentNoteUserListDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
      case DocumentNoteUserListActionDispatchTypes.DOCUMENT_NOTE_USER_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
      case DocumentNoteUserListActionDispatchTypes.DOCUMENT_NOTE_USER_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
      case DocumentNoteUserListActionDispatchTypes.DOCUMENT_NOTE_USER_LIST_RESET: {
      return initialState;
    }
      case DocumentNoteUserListActionDispatchTypes.DOCUMENT_NOTE_USER_LIST_FORBIDDEN: {
      return {
        response: initialState.response,
        loading: false,
      };
    }
  }
  return state;
};

export default DocumentNoteUserListReducer;
